import React, { useState, useEffect } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { AutoCoderPipeline } from '../../types/gotypes'

interface ExtractFrameworkDialogProps {
  open: boolean
  pipeline: AutoCoderPipeline | null
  onClose: () => void
  onExtract: (name: string, description: string) => void
  isLoading: boolean
}

const ExtractFrameworkDialog: React.FC<ExtractFrameworkDialogProps> = ({
  open,
  pipeline,
  onClose,
  onExtract,
  isLoading,
}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  // Pre-populate name from pipeline name when dialog opens
  useEffect(() => {
    if (open && pipeline?.config?.name) {
      setName(`${pipeline.config.name} Framework`)
      setDescription('')
    }
  }, [open, pipeline])

  const handleSubmit = () => {
    if (!name.trim()) return
    onExtract(name.trim(), description.trim())
  }

  const handleClose = () => {
    if (isLoading) return
    setName('')
    setDescription('')
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Save Pipeline Framework</DialogTitle>
      <DialogContent>
        <TextField
          label="Framework Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          required
          margin="normal"
          autoFocus
          disabled={isLoading}
        />
        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          multiline
          rows={3}
          margin="normal"
          placeholder="Optional description for this framework"
          disabled={isLoading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!name.trim() || isLoading}
        >
          {isLoading ? 'Saving...' : 'Save Framework'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExtractFrameworkDialog
